export default "__VITE_ASSET__BUBk9L2A__"